import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';
import { SxProps, Theme } from '@mui/material';

interface Props {
    value: number | null;
    onChange: (value: number | null) => void;
    label?: string;
    helperText?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    fullWidth?: boolean;
    size?: 'small' | 'medium';
    sx?: SxProps<Theme>;
}

/// Campo de dinheiro para telas sem react-hook-form; o equivalente do formulário é Form.NumericInput.
/// Evita type="number": aceita 1e5, não separa milhar e mostra setinhas num preço.
export const CurrencyInput = ({
    value, onChange, label, helperText, disabled, autoFocus, fullWidth, size = 'small', sx,
}: Props) => (
    <NumericFormat
        value={value ?? ''}
        onValueChange={(values) => onChange(values.floatValue ?? null)}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        allowNegative={false}
        prefix="R$ "
        customInput={TextField}
        label={label}
        helperText={helperText}
        disabled={disabled}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        size={size}
        sx={sx}
    />
);
